import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  glFund: '',
  department: '',
  account: '',
  govFunction: '',
  purpose: '',
  amountRequested: '',
  amountApproved: '',
};

export const axAppropriationsUtils = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
  }),
  mutations: {
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  actions: {
    async loadaxAppropriationRecords({ commit, dispatch }, {
      criteria, baseCrudKey, postProcess,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query axAppropriations($criteria: AxAppropriationsCriteriaType) {
            axAppropriations(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
            }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { axAppropriations } = results.data;
          const postProcessed = postProcess ? postProcess(axAppropriations) : axAppropriations;
          commit('base/crud/setItems', [baseCrudKey, postProcessed], { root: true });
          return postProcessed;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
      return [];
    },
    async upsertAxAppropriationsRecords({ dispatch, commit }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertAxAppropriations($item: [AxAppropriationsInputType]!)  {
            upsertAxAppropriations(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        // const axAppropriations = rootGetters['base/crud/items'](baseCrudKey);
        // const newAxAppropriation = results.data.upsertAxAppropriations;
        // commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
        dispatch('flashSuccess', 'record saved Successfully', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the List', { root: true });
      }
    },
    async deleteAxAppropriationsRecords({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteAxAppropriations ($id: ID!)  {
            deleteAxAppropriations(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteAxAppropriations._id;
        const deleteAxAppropriationsData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = deleteAxAppropriationsData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the List', { root: true });
      }
    },
    async clearAllAxAppropriations({ dispatch, commit }, { fundNo, baseCrudKey, postProcess }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation clearAllAxAppropriations($fundNo: String) {
            clearAllAxAppropriations(fundNo: $fundNo) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: { fundNo },
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const cleared = results.data.clearAllAxAppropriations;
          const postProcessed = postProcess ? postProcess(cleared) : cleared;
          commit('base/crud/setItems', [baseCrudKey, postProcessed], { root: true });
          dispatch('flashSuccess', 'All amounts cleared successfully', { root: true });
          return postProcessed;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem clearing amounts', { root: true });
      }
      return [];
    },
  },
};

export default axAppropriationsUtils;
